import { MonoTypeOperatorFunction, map } from 'rxjs';

/**
 * @returns
 * Operator that emits with the flipped `boolean` value of the source
 */
export function booleanInvert(): MonoTypeOperatorFunction<boolean> {
  return map((value) => !value);
}
